import React from "react";

interface TiktokIconProp {
    width?: number;
    height?: number;
    fill1?: string;
    fill2?: string;
    className?: string;
};

const Tiktok: React.FC<TiktokIconProp> = ({ width, height, fill1, fill2, className}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 88 100"
            fill="none"
            className={className}>
            <g clipPath="url(#clip0_862_571)">
                <path d="M65.2162 36.0072C71.6367 40.609 79.5024 43.3165 87.9975 43.3165V26.9269C86.3896 26.9275 84.7861 26.7592 83.2132 26.4248V39.3259C74.7188 39.3259 66.8541 36.6186 60.4322 32.0172V65.4641C60.4322 82.1962 46.9036 95.7589 30.2166 95.7589C23.9902 95.7589 18.2029 93.8717 13.3955 90.6348C18.8824 96.26 26.5343 99.7493 34.9995 99.7493C51.6879 99.7493 65.2168 86.1865 65.2168 69.4538V36.0072H65.2162ZM71.1183 19.4721C67.8369 15.8779 65.6823 11.2331 65.2162 6.09792V3.98999H60.6824C61.8237 10.5165 65.7167 16.0924 71.1183 19.4721ZM23.95 77.7955C22.1166 75.3858 21.1256 72.4373 21.1302 69.4059C21.1302 61.7534 27.3181 55.5486 34.9524 55.5486C36.3749 55.5478 37.7891 55.7668 39.1451 56.1979V39.4417C37.5604 39.2241 35.9613 39.1314 34.3629 39.1655V52.2076C33.0062 51.7764 31.5913 51.5575 30.1681 51.5586C22.5341 51.5586 16.3466 57.7628 16.3466 65.4162C16.3466 70.8279 19.4393 75.5131 23.95 77.7955Z" fill={fill1 ?? "currentColor"} />
                <path d="M83.2133 26.4241V22.9366C78.9374 22.9428 74.746 21.7422 71.1181 19.4721C74.3294 22.9969 78.558 25.4277 83.2133 26.4248M60.6822 3.98966C60.5735 3.36606 60.49 2.7383 60.4319 2.10793V0H43.989V65.4638C43.9629 73.0948 37.7857 79.2741 30.1675 79.2741C28.0078 79.2774 25.8776 78.771 23.9491 77.7959C26.4746 81.119 30.4628 83.2638 34.9515 83.2638C42.569 83.2638 48.7468 77.0852 48.7737 69.4534V3.99L60.6822 3.98966ZM34.3633 39.1655V35.4521C32.9893 35.2639 31.6041 35.1697 30.2173 35.17C13.5283 35.17 0 48.7334 0 65.4638C0 75.9531 5.31678 85.1972 13.3963 90.6348C8.06747 85.1735 4.78431 77.6983 4.78431 69.4531C4.78431 52.9359 17.9685 39.5052 34.3633 39.1655Z" fill={fill2 ?? "currentColor"} />
            </g>
            <defs>
                <clipPath id="clip0_862_571">
                    <rect width="88" height="100" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Tiktok

